<template>
  <div>
    <h1>Belgian Waffles Adjuster</h1>
    <label for="scale">Scale recipe: {{ scale.toFixed(2) }}x</label>
    <div class="slider-container">
      <input
        type="range"
        id="scale"
        min="0.1"
        max="2"
        step="0.05"
        v-model.number="scale"
      />
      <div class="slider-markers">
        <span v-for="value in markers" :key="value" :style="{ left: `${(value - 0.1) / 1.9 * 100}%` }">
          |
        </span>
      </div>
    </div>

    <div class="ingredients">
      <h2>Ingredients</h2>
      <ul>
        <li>Milk: <strong>{{ milk.toFixed(2) }} cups</strong></li>
        <li>Instant yeast: <strong>{{ yeast.toFixed(2) }} tsp</strong></li>
        <li>Butter: <strong>{{ butter.toFixed(2) }} cups</strong></li>
        <li>Sugar: <strong>{{ sugar.toFixed(2) }} Tbsp</strong></li>
        <li>Salt: <strong>{{ salt.toFixed(2) }} tsp</strong></li>
        <li>Whole eggs: <strong>{{ eggs.toFixed(1) }}</strong></li>
        <li>Egg yolk: <strong>{{ eggYolk.toFixed(1) }}</strong></li>
        <li>Flour: <strong>{{ flour.toFixed(2) }} cups ({{ Math.round(flour * 150) }}g)</strong></li>
      </ul>
    </div>

    <div class="recipe">
      <h2>Recipe</h2>
      <ol>
        <li>
          In a medium bowl, add <strong>{{ milk.toFixed(2) }} cups</strong> of milk and whisk in <strong>{{ yeast.toFixed(2) }} tsp</strong> instant yeast, and set to the side.
        </li>
        <li>
          In a large bowl, add in <strong>{{ eggs.toFixed(1) }} whole eggs</strong> and <strong>{{ eggYolk.toFixed(1) }} egg yolk</strong> then whisk to combine.
        </li>
        <li>
          Whisk in the yeast mixture until thoroughly combined then gently whisk in <strong>{{ butter.toFixed(2) }} cups</strong> melted unsalted butter.
        </li>
        <li>
          In a large bowl, add <strong>{{ flour.toFixed(2) }} cups</strong> all-purpose flour, <strong>{{ sugar.toFixed(2) }} Tbsp</strong> granulated sugar, and <strong>{{ salt.toFixed(2) }} tsp</strong> kosher salt. Whisk together.
        </li>
        <li>Whisk wet ingredients into the dry ingredients until smooth.</li>
        <li>Wrap and let rest and rise for 1 hour or overnight.</li>
        <li>
          Heat waffle maker to manufacturer’s instructions and spray lightly with cooking spray.
        </li>
        <li>
          Add ¾ cup, or 1 cup of batter to the center of the waffle maker, close gently with a little press, and let cook for the recommended time.
        </li>
        <li>Remove finished waffle and repeat with remaining batter.</li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: "BelgianWaffles",
  data() {
    return {
      scale: 1,
      original: {
        milk: 1.6,
        yeast: 1.6,
        butter: 1 / 3,
        sugar: 2,
        salt: 1,
        eggs: 2,
        eggYolk: 1,
        flour: 2,
      },
      markers: Array.from({ length: 8 }, (_, i) => 0.25 * (i + 1)), // Generate markers at 0.25 intervals
    };
  },
  computed: {
    milk() {
      return this.original.milk * this.scale;
    },
    yeast() {
      return this.original.yeast * this.scale;
    },
    butter() {
      return this.original.butter * this.scale;
    },
    sugar() {
      return this.original.sugar * this.scale;
    },
    salt() {
      return this.original.salt * this.scale;
    },
    eggs() {
      return Math.round(this.original.eggs * this.scale * 10) / 10;
    },
    eggYolk() {
      return Math.round(this.original.eggYolk * this.scale * 10) / 10;
    },
    flour() {
      return this.original.flour * this.scale;
    },
  },
};
</script>

<style scoped>
h1 {
  margin-bottom: 1rem;
}
input[type="range"] {
  width: 100%;
  margin-bottom: 1rem;
}
.slider-container {
  position: relative;
  width: 100%;
}
.slider-markers {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 0;
  pointer-events: none;
}
.slider-markers span {
  position: absolute;
  transform: translateY(-50%);
  font-size: 1rem;
  color: #aaa;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  margin: 0.5rem 0;
}
strong {
  color: #d14;
}
.recipe {
  margin: 20px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
}
ol {
  display: flex;
  flex-direction: column;
  padding: 0;
  list-style-position: inside; /* Center list item numbers */
}
.ingredients {
  margin: 20px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
}
</style>